import { formatCurrency, getCurrencySymbol } from '@angular/common';
import { Component, Inject, Input, LOCALE_ID, OnInit } from '@angular/core';
import { LocalizationConfigService, StoreConfigService, StoreSpecificConfigService } from '@scalefast/config-angular';
import { LoginService, StaticFileHash, SubscribeNewsletterModalService } from '@scalefast/ecommerce-core';
import { AppPopoverWrapperComponent } from 'src/app/shared/components/popover/popover-wrapper/popover-wrapper.component';

@Component({
  selector: 'app-product-benefits',
  styleUrls: ['./product-benefits.component.scss'],
  templateUrl: './product-benefits.component.html',
  standalone: true,
  imports: [AppPopoverWrapperComponent, StaticFileHash],
})
export class AppProductBenefitsComponent implements OnInit {
  @Input() productPriceInfo: any;
  @Input() productStock: any;
  @Input() isPohProduct = false;

  loginUrl: string;
  accountUrl: string;
  freeShippingValue: number;
  freeShippingValueString: string;
  klarnaMinValue: number;
  productPrice: number | undefined;
  klarnaInstallments: number;
  klarnaPayments: number | undefined;
  klarnaStringPayments: string | null | undefined;
  freeShippingAmountLeft: number | undefined;
  freeShippingAmountLeftString: string | undefined;

  readonly currencySymbol: string;
  readonly currency;

  constructor(
    @Inject(LOCALE_ID) protected locale: string,
    private localizationConfigService: LocalizationConfigService,
    private storeConfigService: StoreConfigService,
    private loginService: LoginService,
    private storeSpecificConfigService: StoreSpecificConfigService,
    private subscribeNewsletterModalService: SubscribeNewsletterModalService,
  ) {
    this.freeShippingValue = this.storeSpecificConfigService.get().freeShippingValue;
    this.klarnaMinValue = 105;
    this.klarnaInstallments = 3;
    this.currency = this.localizationConfigService.get().currency;
    this.currencySymbol = getCurrencySymbol(this.currency, 'narrow', this.locale);
    this.freeShippingValueString = formatCurrency(
      this.freeShippingValue,
      this.locale,
      this.currencySymbol,
      this.currency,
      '1.2-2',
    );
    this.loginUrl = this.storeConfigService.getCustomRoutes()?.login ?? 'sso_login';
    this.accountUrl = this.storeConfigService.getCustomRoutes()?.account ?? 'account';
  }

  ngOnInit(): void {
    this.productPrice = this.productPriceInfo.prices[0].price;
    if (this.productPrice && this.productPrice >= this.klarnaMinValue) {
      this.klarnaPayments = this.productPrice / this.klarnaInstallments;
      this.klarnaStringPayments = formatCurrency(
        this.productPrice / this.klarnaInstallments,
        this.locale,
        this.currencySymbol,
        this.currency,
        '1.2-2',
      );
    }
    if (this.productPrice && this.productPrice < this.freeShippingValue) {
      this.freeShippingAmountLeft = this.freeShippingValue - this.productPrice;
      this.freeShippingAmountLeftString = formatCurrency(
        this.freeShippingValue - this.productPrice,
        this.locale,
        this.currencySymbol,
        this.currency,
        '1.2-2',
      );
    }
  }

  clickOpenNewsletterModal($event: any): void {
    $event.preventDefault();
    this.subscribeNewsletterModalService.showModal();
  }

  goToLogin(): void {
    /**
     * @FIXME Here we SHOULD use angular's router and navigate() method instead of window.location,
     * but because of the login page is hosted on v4 connection we need to reload the page, and we can't do that with angular router navigate.
     * Once the login page is hosted in v5 we need to make the switch to angular router navigate.
     */
    window.location.href = this.loginUrl;
  }

  accountSectionURL(section: string): string {
    /**
     * @FIXME Here we SHOULD use angular's router and navigate() method instead of window.location,
     * but because of the login page is hosted on v4 connection we need to reload the page, and we can't do that with angular router navigate.
     * Once the login page is hosted in v5 we need to make the switch to angular router navigate.
     */
    return this.loginService.isLoggedSync() ? `${this.accountUrl}#/${section}` : this.loginUrl;
  }
}
